import {Component, ViewEncapsulation} from '@angular/core';
import {DialogsService, NavigateService} from 'ngx-satoris';
import {CartService} from '../../shared/services/cart.service';
import {ApiService} from '../../shared/services/api.service';
import {DialogNewPersonComponent} from '../../components/dialogs/dialog-new-person/dialog-new-person.component';
import {environment} from '../../../environments/environment';
import {DocumentType} from '../../shared/models/user';

@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PeopleComponent {

  constructor(private dialog: DialogsService,
    public nav: NavigateService,
    public cart: CartService,
    public api: ApiService) {}

  ngOnInit(): void {
    this.cart.removeOneElementOLD('person_id');
    this.cart.scenario !== 'person' && this.cart.removeOneElementOLD('state');
  }

  onClick(personId: number) {
    if(this.cart.cartDatas?.fromRoute === 'document') {
      this.cart.setStorageOLD({person_id: +personId});
      if(environment.type === DocumentType.ZWEVISA) {
        this.nav.to('form-visa');
      } else {
        console.log('to selfie payment');
        this.nav.to('selfie-payment');
      }
    } else {
      this.nav.to('people/' + personId);
    }
  }

  /*onClick(personId: number) {
    this.nav.to('people/' + personId);
  }*/

  openDialogNewPerson() {
    this.dialog.openDialog(DialogNewPersonComponent, 'md');
  }
}
